









import {Component, Prop, Vue} from 'vue-property-decorator';

@Component
export default class Dimmer extends Vue {
    @Prop({type: Boolean, default: false}) public active!: boolean;
    @Prop({type: Boolean, default: false}) public error!: boolean;
}
